import { asyncLoad } from '@util'

const SiYiTeamGroupMember = asyncLoad(() =>
  import('@components/LocalMerchant/SiYiTeamGroupMember')
)

export default [
  {
    path: 'siYiTeamGroupMember',
    component: SiYiTeamGroupMember,
    stat: '团队成员'
  }
]
